<div class="body-header">
  <div class="header-btn-container">
    <app-autocomplete *ngIf="featureInputSearch"
      class="product-search-autocomplete"
      inputId="product-search-autocomplete" 
      placeholder="Cep, endereço ou condomínio"
      [height]="'36px'" [emitIndex]="true"
      [autoSearchResults]="autoSearchResults"
      [onlyDescription]="false"
      (ElementSelected)="patchInputValue()"
      (autocompleteSearch)="searchAutocomplete($event)"
      value="valueSearchInput"
      [enhanveOnHover]="false">
    </app-autocomplete>
    <div class="reg-input" *ngIf="!featureInputSearch">
      <input
        type="text"
        id="new-product-reg-search"
        name="reg-search"
        class="reg-input-control"
        placeholder="Cep, endereço ou condomínio"
        autocomplete="off"
        [(ngModel)]="valueSearchInput"
        (input)="searchAutocomplete(valueSearchInput)"
        (keydown.enter)="selectAutocomplete()"
        (keydown)="downList($event)"
        maxlength="300">
      <button class="btn-search" (click)="searchProduct(1)">
        <img src="../../../../assets/svgs/search.svg" alt="Buscar">
      </button>
    </div>
    <div class="reg-input-autocomplete" *ngIf="autocomp && autoSearchResults.length > 0 && !featureInputSearch">
      <div
        id="autocomplete-result-{{i}}"
        class="autocomplete-item"
        [ngClass]="{'keyHover': i === autocompIdx}"
        (pointerover)="pointerSelection(i)"
        (click)="patchInputValue()"
        *ngFor="let result of autoSearchResults; let i = index">
        <span [innerHTML]=result.type></span>
        <span>:&nbsp;</span>
        <span [innerHTML]=result.description></span>
      </div>
    </div>
    <button class="map-btn" (click)="toggleMap()"  matTooltip="{{showMap ? 'Fechar mapa' : 'Abrir mapa'}}">
      <img *ngIf="!showMap"  src="../../../../assets/svgs/map_black.svg" alt="Icones Maps"> 
      <img *ngIf="showMap" src="../../../../assets/svgs/map_red.svg" alt="Icones Maps"> 
      <span class="map-btn-label">Mapa</span>
    </button>
  </div>
  <div class="filter-container" *ngIf="!loading && properties.length !== 0">
    <app-dropdown-button [isOpen]="orderOpen"
      (valueChange)="orderOpen = $event"
      [label]="order.value"
      [alignRight]=true>
      <ul class="dropdown-text-list">
        <div id="product-reg-order-{{i}}" *ngFor="let item of orderList; let i = index">
          <li (click)="setFilter(item)">
            {{item.value}}                  
          </li>
        </div>           
      </ul>
    </app-dropdown-button>
  </div>
</div>
<div class="body-list" *ngIf="!loading && (!search || properties.length > 0)">
  <div class="gradient" *ngIf="true"></div>
  <div class="body-tip">
    <span>Busque e selecione o imóvel o qual deseja cadastrar</span>
  </div>
  <div [ngStyle]="{'visibility': search ? 'inherit' : 'hidden'}" class="result-title">
    <span id="product-search-result" style="font-weight: bold;">{{links.total_items < 10 ? '0' + links.total_items : links.total_items}}</span> <span> {{links.total_items === 1 ? 'Imóvel encontrado' : 'Imóveis encontrados'}}</span>
  </div>
  <div (scroll)="checkScroll()" class="result-list scroll-bar">
      <div class="result-card" id="product-card-result{{i}}" *ngFor="let card of properties; let i = index; let last = last;">
        <app-product-reg-card id="{{last ? 'last-message' : ''}}" [data]="card" (click)="openModal()"></app-product-reg-card>
      </div>
      <div class="card-loader" *ngIf="fetching">
        <lib-loading></lib-loading>
      </div>
      <div class="spacing"></div>
  </div>
</div>
<div id="no-product-found-message" class="body-list not-found" *ngIf="!loading && search && properties.length === 0">
  <div class="body-tip-not-found">
    <span class="not-found-face">;(</span>
    <span class="not-found-msg">Nenhum imóvel encontrado</span>
    <span class="not-found-tip">Realize uma nova busca ou cadastre um</span>
    <a class="a-link not-found-tip" href="#">novo produto.</a>
  </div>
</div>
<div *ngIf="loading" class="body-list loader"> 
  <lib-loading></lib-loading>
</div>